export default "__VITE_ASSET__D0EcH8Jq__"